
import { defineComponent, ref, reactive, computed } from 'vue'
import { errManager, showNotification } from "@/core/config/Tools";
import { useStore } from "vuex";
import GlobalService from '@/core/services/GlobalService';
import { useI18n } from "vue-i18n/index";
import moment from 'moment';

import DialogOrderDetail from '@/views/payments/modals/DialogOrderDetail.vue';

export default defineComponent({
    props:{
        rowClub: {
            type: null,
            required: false,
            default: () => ({})
        }
    },
    components: { DialogOrderDetail },
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const altura = screen.height - 250;
        const listOrders = ref<any[]>([]);
        const DialogOrderDetailRef = ref<any>(null);
        

        const openModal = () => {
            isModalVisible.value = true
        };

        const onOpen = () => {
            titleDialog.value = `Ordenes de pago de ${props.rowClub?.name}`
            //const hasData = props.itemOrder && Object.keys(props.itemOrder).length > 0;
            //titleDialog.value = hasData ? t('edit'): t('register')
            //if (hasData) getOrders();
        };

        const onClosed = () => {
            //resetForm(ruleFormRef.value)
            //Object.keys(form).forEach(key => delete form[key]);
        };

        const generarOrder = () => {
            if(DialogOrderDetailRef.value){
                DialogOrderDetailRef.value.openModal();
            }
        }

        return {
            t,
            loading,
            titleDialog,
            isModalVisible,
            altura,
            moment,
            listOrders,
            DialogOrderDetailRef,
            //events
            openModal,
            onOpen,
            onClosed,
            generarOrder

        }
        
    },
})
